import { print } from 'graphql';
import type { MigrationStrategies, RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { gql } from '../../graphql/Client';
import { rootStore } from '../../mobx-models/Root';
import { BaseEntity } from '../../models/BaseEntity';
import { SYNC_LIMIT_LOW } from '../../utilities/constants';
import RxdbCollectionName from '../rxdbCollectionName';
import defaultDoc from '../Shared/defaultDoc';

export interface Equipment extends BaseEntity {
  readonly equipmentTypeId: string;
  readonly blockId: string;
  readonly panelId: string;
  readonly roomId: string;
  readonly shortName: string | null;
  readonly longName: string;
  readonly surveyPointId: string;
  readonly isActive: boolean;
  readonly assignedBorerEquipmentId: string | null;
}
export type EquipmentCollection = RxCollection<Equipment> | null;
export type EquipmentDocument = RxDocument<Equipment>;

export const equipmentSchema: RxJsonSchema<Equipment> = {
  type: 'object',
  version: 3,
  description: 'describes a Equipment object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    equipmentTypeId: { ref: RxdbCollectionName.EQUIPMENT_TYPE, type: 'string' },
    blockId: { ref: RxdbCollectionName.BLOCKS, type: ['string', 'null'] },
    panelId: { ref: RxdbCollectionName.PANELS, type: ['string', 'null'] },
    roomId: { ref: RxdbCollectionName.ROOMS, type: ['string', 'null'] },
    surveyPointId: {
      ref: RxdbCollectionName.SURVEY_POINTS,
      type: ['string', 'null'],
    },
    shortName: { type: ['string', 'null'] },
    longName: { type: 'string' },
    isDeleted: { type: 'boolean' },
    updatedAt: { type: 'number' },
    version: { type: 'number' },
    isActive: { type: 'boolean' },
    assignedBorerEquipmentId: {
      type: ['string', 'null'],
    },
  },
};

export const equipmentMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: EquipmentDocument) => oldDoc,
  2: (oldDoc: EquipmentDocument) => oldDoc,
  3: (oldDoc: EquipmentDocument) => ({
    ...oldDoc,
    assignedBorerEquipmentId: oldDoc.assignedBorerEquipmentId || null,
  }),
};

export const equipmentPullQueryBuilder = (doc: Equipment) => {
  if (!doc) {
    doc = { ...defaultDoc, updatedAt: 0 };
  }

  const query = print(gql`
    query equipmentFeed($siteId: ID!, $lastUpdateAt: Float!, $limit: Int!) {
      equipmentFeed(lastUpdateAt: $lastUpdateAt, limit: $limit, siteId: $siteId) {
        id
        equipmentTypeId
        blockId
        panelId
        roomId
        isDeleted
        updatedAt
        version
        shortName
        longName
        surveyPointId
        isActive
        assignedBorerEquipmentId
      }
    }
  `);

  return {
    query,
    variables: {
      siteId: rootStore.user.siteId,
      lastUpdateAt: doc.updatedAt,
      limit: SYNC_LIMIT_LOW,
    },
  };
};

export default {};
